import { render, staticRenderFns } from "./LoginCheckPage.vue?vue&type=template&id=9bcddf26&"
import script from "./LoginCheckPage.vue?vue&type=script&lang=ts&"
export * from "./LoginCheckPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports